import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { mergeProps } from '@react-aria/utils';
export function usePress(_ref) {
  var isDisabled = _ref.isDisabled,
      _onPress = _ref.onPress,
      onPressStart = _ref.onPressStart,
      onPressEnd = _ref.onPressEnd,
      onPressUp = _ref.onPressUp,
      onPressChange = _ref.onPressChange,
      isPressedProp = _ref.isPressed,
      restProps = _objectWithoutProperties(_ref, ["isDisabled", "onPress", "onPressStart", "onPressEnd", "onPressUp", "onPressChange", "isPressed"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isPressed = _React$useState2[0],
      setPressed = _React$useState2[1];

  var pressProps = {
    onPress: function onPress(e) {
      if (isDisabled) return;
      _onPress && _onPress(e);
    },
    onPressIn: function onPressIn(e) {
      if (isDisabled) return;
      onPressStart && onPressStart(e);
      setPressed(true);
      onPressChange && onPressChange(true);
    },
    onPressOut: function onPressOut(e) {
      if (isDisabled) return;
      onPressEnd && onPressEnd(e);
      setPressed(false);
      onPressChange && onPressChange(false);
      onPressUp && onPressUp(e);
    }
  };
  pressProps = mergeProps(pressProps, restProps);
  return {
    isPressed: isPressedProp || isPressed,
    pressProps: pressProps
  };
}